import React from 'react';
import { IFormState } from '../../utilities/types/buybox';

export interface IInputComponentProps {
    label: string;
    name: string;
    errorID: string;
    value: string;
    onChange: (value: React.SetStateAction<IFormState>) => void;
    inputType?: string;
    inputMaxLength?: number;
    errorMessage?: string;
    isRequired?: boolean;
    requiredText?: string;
}

const Input: React.FC<IInputComponentProps> = props => {
    const { label, name, errorID, value, onChange, inputMaxLength, inputType, errorMessage, isRequired, requiredText } = props;
    return (
        <div className='col-sm-4'>
            <div className='form-group'>
                <label htmlFor={name}>
                    {label}
                    {isRequired && <span className='staric'>{requiredText}</span>}
                </label>
                <input
                    name={name}
                    id={name}
                    aria-describedby={errorID}
                    value={value}
                    onChange={e => onChange({ value: e.target.value })}
                    className='form-field'
                    type={inputType || 'text'}
                    maxLength={inputMaxLength}
                    required={isRequired || false}
                />
                <div id={errorID} className='cui alert-small error'>
                    {errorMessage}
                </div>
            </div>
        </div>
    );
};

export default Input;
